import React, { useState, useEffect, useCallback } from "react";
import { Edit, Delete } from "@mui/icons-material";
import Swal from "sweetalert2";
import CustomPagination from "../../Components/Pagination/CustomPagination";
import usePagination from "../../hooks/UsePagination";
import Spineer from "../../Components/CustomSpineer/Spineer";
import DashboardModalAffiliateCode from "./DashboardModalAffiliateCode";

const AdminAffiliateCode = () => {
  const [modalShow, setModalShow] = useState(false);
  const [editingCode, setEditingCode] = useState(null);
  const [codes, setCodes] = useState([]);
  console.log(codes)
  const [loading, setLoading] = useState(true);
  const AdminToken = localStorage.getItem("AiAdmin");

  const fetchCodes = useCallback(() => {
    setLoading(true);
    fetch("https://backend.whalesai.com/api/v1/affiliate-code", {
      headers: {
        Authorization: `Bearer ${AdminToken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setCodes(data.result || data.data || data || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, [AdminToken]);

  useEffect(() => {
    fetchCodes();
  }, [fetchCodes]);

  let [page, setPage] = useState(1);
  const PER_PAGE = 10;
  let count = Math.ceil((codes?.length || 0) / PER_PAGE);
  let perPageData = usePagination(codes || [], PER_PAGE);

  const handlePageChange = (e, p) => {
    setPage(p);
    perPageData.jump(p);
  };

  const handleEdit = (code) => {
    setEditingCode(code);
    setModalShow(true);
  };

  const handleAdd = () => {
    setEditingCode(null);
    setModalShow(true);
  };

  const handleDelete = (id) => {
    Swal.fire({
      text: "Are you sure, you want to delete this affiliate code?",
      icon: "warning",
      showDenyButton: true,
      confirmButtonText: "Yes",
      customClass: "modal_class_success",
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(`https://backend.whalesai.com/api/v1/affiliate-code/${id}`, {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${AdminToken}`,
          },
        })
          .then((response) => {
            if (response.ok) {
              fetchCodes();
              Swal.fire({
                html: `<p class='text-break text-white'>Affiliate Code Deleted.</p>`,
                icon: "success",
                customClass: "modal_class_success",
              });
            } else {
              Swal.fire({
                text: "Failed to delete the code.",
                icon: "error",
                background: "#011225",
              });
            }
          })
          .catch((error) => {
            console.log("error from catch", error);
            Swal.fire({
              text: "An error occurred while deleting the code.",
              icon: "error",
              background: "#011225",
            });
          });
      }
    });
  };

  return (
    <div className="container-fluid text-white">
      <h5 className="text-start mb-3 font-weight-bold">AFFILIATE CODE</h5>
      
      <div
        className="table-responsive pt-3 rounded my-2 mb-5"
        style={{ backgroundColor: "#3080AC", paddingBottom: "10px" }}
      >
        <div className="mx-3">
          <div className="d-flex justify-content-end gap-2 mb-2 mr-3">
            <button
              onClick={handleAdd}
              className="btn btn-primary mb-1 admin-add-text"
            >
              ADD NEW
            </button>
          </div>
        </div>

        <div className="table-responsive overflow-auto">
          <table
            className="table table-text table-hover"
            style={{ backgroundColor: "#3080AC" }}
          >
            <thead className="bg-[#1a1c339a]">
              <tr>
                <th scope="col">S/no</th>
                <th scope="col">Code</th>
                <th scope="col">Credit</th>
                <th scope="col" className="d-none d-md-table-cell">
                  Created By
                </th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody style={{ backgroundColor: "#3080AC" }}>
              {!loading && codes && codes.length > 0 ? (
                perPageData?.currentData()?.map((item, index) => (
                  <tr key={item._id || index}>
                    <td className="px-4 py-4">{(page - 1) * 10 + index + 1}</td>
                    <td className="py-4">{item.code}</td>
                    <td className="py-4">{item.credit}</td>
                    <td className="d-none py-4 d-md-table-cell">
                      {item.createdBy?.email || 'Admin'}
                    </td>
                    <td className="alignment">
                      <div className="btn-group gap-2" role="group">
                        <button
                          className="btn rounded-circle btn-sm icon-body btn-success"
                          onClick={() => handleEdit(item)}
                        >
                          <Edit className="action-icon" />
                        </button>
                        <button
                          className="btn rounded-circle btn-sm icon-body btn-danger"
                          onClick={() => handleDelete(item._id)}
                        >
                          <Delete className="action-icon" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    className="text-center"
                    colSpan={window.innerWidth <= 768 ? "4" : "5"}
                  >
                    {loading ? <Spineer /> : "No affiliate codes found."}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {!loading && codes && codes.length > 0 && (
          <CustomPagination
            page={page}
            count={count}
            onChange={handlePageChange}
          />
        )}
      </div>

      <DashboardModalAffiliateCode
        show={modalShow}
        onHide={() => setModalShow(false)}
        refetch={fetchCodes}
        editingCode={editingCode}
      />
    </div>
  );
};

export default AdminAffiliateCode;